module.exports = __webpack_public_path__ + "static/media/05B2.53c96f1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/05B2.png
// module id = 271
// module chunks = 0